import { render, staticRenderFns } from "./PageAdminTenantProfile.vue?vue&type=template&id=10879a20"
import script from "./PageAdminTenantProfile.vue?vue&type=script&lang=js"
export * from "./PageAdminTenantProfile.vue?vue&type=script&lang=js"
import style0 from "./PageAdminTenantProfile.vue?vue&type=style&index=0&id=10879a20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports